import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../../components/common/Spinner.js"
import ContentWrapper from '../../../components/common/AssessmentContentWrapper';
import AdminTemplate from '../../../components/admin/layouts/Template';
import Card from '../../../components/common/Card';
import CardHeader from '../../../components/common/CardHeader';
import CardBody from '../../../components/common/CardBody';
import CardTitle from '../../../components/common/AssessmentCardTitle';
import Input from '../../../components/common/form/Input';
import Button from '../../../components/common/form/Button';
import QuestionAccordion from '../../../components/common/form/QuestionAccordion';
import TabList from '../../../components/common/tabs/TabList';
import Form from "react-bootstrap/Form";
import TabContent from '../../../components/common/tabs/TabContent';
import TabPane from '../../../components/common/tabs/TabPane';
import ReactSpinner from "react-bootstrap/Spinner";
import Option from '../../../components/common/form/Option';
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import { quesSubjectActions } from "../../../actions/settings/question/subjectAction.js"
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import config from "../../../helper/config.js";
import {customerConstants} from "../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnColor, closeBtnColor, cancelClass, confirmClass
const customer = getCustomerFeatureFlag()
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    closeBtnColor = "var(--maincolor)"
    addBtnColor = "var(--maincolor)"
    cancelClass = "btn-default"
    confirmClass = "btn-primary"
    break
  case customerConstants.EXO_CUSTOMER2:
    closeBtnColor = "var(--maincolor-cmc)"
    addBtnColor = "var(--maincolor-cmc)"
    break
  default:
    closeBtnColor = "var(--maincolor)"
    addBtnColor = "var(--maincolor)"
    cancelClass = "btn-default"
    confirmClass = "btn-primary"
    break
}

class QuestionSubject extends Component {
    constructor(props) {
      super(props);
      this.state = {
        newSubject:null,
        subjectRowsPerPage:5,
        currentSubjectPage: 0,
        subjectData: [],
        subject_sort_column: "subject_id",
        subject_sort_direction: "ASC",
        selectSubject: '',
        editSubject: false,
        subject: '',
        limit: 10,
        subject_search_term: "",
        subject_offset: 0,
        searchError: false,
        subject_limit:5,
        subjectId: '',
        subjectOptionsImport: [],
        selectedSubject: []
      };
      
      this.onNewSubjectInput = this.onNewSubjectInput.bind(this);
      this.onAddNewSubject = this.onAddNewSubject.bind(this);
      this.generateSubjectOptions = this.generateSubjectOptions.bind(this);
    }

    componentDidMount(){        
        this.fetchAllQuestionSubjects();
    }
    
    onNewSubjectInput(e) {
        this.setState({
            newSubject: e.target.value
        });
    }
    
    async onAddNewSubject(e) {
        if (this.state.newSubject && this.state.newSubject.trim()) {
            await this.props.createSubject({ 'subject': this.state.newSubject })
            if (this.props.successsubjectcreate) {
                this.setState(
                    {
                        subject_offset: 0,
                        currentSubjectPage: 0,
                        searchError: false,
                    },
                    () => {
                        this.fetchAllQuestionSubjects();
                        this.generateSubjectOptions();
                        window.Swal.fire({
                            title: 'Success!',
                            text: 'Added new subject!',
                            icon: 'success',
                            customClass: {
                                confirmButton: `btn font-weight-bold ${confirmClass}`,
                            },
                            onOpen: (modalElement) => {
                                if (customer === customerConstants.EXO_CUSTOMER2) {
                                    modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                                }
                            }
                        })
                            .then(function () {
                                window.$('#manage-category').modal('hide')
                                window.$("#question-category").val('default');
                                window.$('#question-category').selectpicker('refresh');
                            });
                    }
                );
            }
            if (this.props.errorsubjectupdate) {
                window.Swal.fire({
                    title: 'Failed to add a new subject!',
                    text: this.props.errorsubjectupdate,
                    icon: 'error',
                    customClass: {
                        confirmButton: `btn font-weight-bold ${confirmClass}`,
                    },
                    onOpen: (modalElement) => {
                        if (customer === customerConstants.EXO_CUSTOMER2) {
                            modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                        }
                    }
                })
                    .then(function () {
                        window.$('#manage-category').modal('hide')
                        window.$("#question-category").val('default');
                        window.$('#question-category').selectpicker('refresh');
                    });

            }
        } else {
            window.Swal.fire({
                title: 'Warning!',
                text: 'Empty subject!',
                icon: 'warning',
                customClass: {
                    confirmButton: `btn font-weight-bold ${confirmClass}`,
                },
                onOpen: (modalElement) => {
                    if (customer === customerConstants.EXO_CUSTOMER2) {
                        modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                    }
                }
            });
        }
        this.setState({
            newSubject: ''
        });
    }

    handleSubjectSearch = (event) => {
        const subject_search_term = event.target.value.trim();
        const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;
        // if (subject_search_term !== "")
        // {
        //     this.setState({limit: this.props.totalCount});
        // }
        if (subject_search_term === "" || regex.test(subject_search_term)) {
            this.setState(
                {
                    subject_search_term,
                    subject_offset: 0,
                    currentSubjectPage: 0,
                    searchError: false,
                },
                () => {
                // Call the debounced version of fetchStudentData
                // this.debouncedHandleSearch();
                    this.fetchAllQuestionSubjects();
                }
            );
        } else {
            this.setState({ subject_search_term, searchError: true });
        }
    };
    
    fetchAllQuestionSubjects = async () => {
        const {
            subject_limit,
            subject_offset,
            subject_sort_column,
            subject_sort_direction,
            subject_search_term
        } = this.state;
        await this.props.getAllQuestionSubjects(subject_limit, subject_offset, subject_sort_column, subject_sort_direction, subject_search_term);
        this.setState({ subject_limit: this.state.subjectRowsPerPage });
        this.setState({ subjectData: this.props.allQuestionSubjects })
    };

    handleSubjectPageChange = (event, newSubjectPage) => {
        const {subjectRowsPerPage} = this.state;
        const newSubjectOffset = newSubjectPage * subjectRowsPerPage;
        this.setState(
        {
            subject_limit: subjectRowsPerPage,
            subject_offset: newSubjectOffset,
            currentSubjectPage: newSubjectPage
        },
        () => {
            this.fetchAllQuestionSubjects();
        }
        );
    };

    handlePageOffsetChange = (newOffset, newPage) => {
        const {subjectRowsPerPage} = this.state;
        this.setState(
        {
            subject_limit: subjectRowsPerPage,
            subject_offset: newOffset,
            currentSubjectPage: newPage
        },
        () => {
            this.fetchAllQuestionSubjects();
        }
        );
    };

    //handle the data fetching as per the data per page limit gets changes
    handleSubjectRowsPerPageChange = (event) => {
        const newSubjectLimit = parseInt(event.target.value, 10);
        this.setState({subjectRowsPerPage: newSubjectLimit});
        const newSubjectPage = Math.floor(this.state.subject_offset / newSubjectLimit)
        this.setState(
        {
            subject_limit: newSubjectLimit,
            subject_offset: newSubjectLimit * newSubjectPage,
            currentSubjectPage: newSubjectPage
        },
        () => {
            this.fetchAllQuestionSubjects();
        }
        );
    };

    handleSortSubjectChange = (subject_sort_column) => {
        // If the same column is clicked, toggle the sort direction
        const { subject_sort_column: currentSubjectSortColumn, subject_sort_direction } = this.state;
        const newSubjectSortDirection =
        currentSubjectSortColumn === subject_sort_column && subject_sort_direction === "ASC"
            ? "DESC"
            : "ASC";

        this.setState(
        {
            subject_sort_column,
            subject_sort_direction: newSubjectSortDirection,
            subject_offset: 0,
            currentSubjectPage: 0,
        },
        () => {
            this.fetchAllQuestionSubjects();
        }
        );
    }

    getQuestionSubject(subject_id) {
        let subjectname
        this.props.allQuestionSubjects.map(subject => {
            if (subject.subject_id === subject_id) {
                return subjectname = subject.subject
            }
        })
        return subjectname
    }
    
    onEditSubject(e, el) {
        this.setState({
            subjectId: el.subject_id,
            subject: e.target.value
        })
    }
    
    async onUpdateSubject(e) {
        e.preventDefault()
        var obj = {
            subject_id: this.state.subjectId,
            subject: this.state.subject
        }
        this.setState({ selectSubject: '' })
        if (!this.state.subject.trim()) {
            window.Swal.fire({
                title: 'Failed to update subject!',
                text: 'Subject cannot be empty!',
                icon: 'error',
                customClass: {
                    confirmButton: `btn font-weight-bold ${confirmClass}`,
                },
                onOpen: (modalElement) => {
                    if (customer === customerConstants.EXO_CUSTOMER2) {
                        modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                    }
                }
            });
        }
        else {
            await this.props.updateSubject(obj);
            if (this.props.successsubjectupdate) {
                // await this.props.getAllQuestionSubjects(subject_limit, subject_offset, subject_sort_column, subject_sort_direction, subject_search_term);
                this.fetchAllQuestionSubjects()
                this.generateSubjectOptions();
                window.Swal.fire({
                    title: 'Success!',
                    text: 'Updated subject!',
                    icon: 'success',
                    customClass: {
                        confirmButton: `btn font-weight-bold ${confirmClass}`,
                    },
                    onOpen: (modalElement) => {
                        if (customer === customerConstants.EXO_CUSTOMER2) {
                            modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                        }
                    }
                })
                    .then(function () {
                        window.$('#manage-category').modal('hide')
                        window.$("#question-category").val('default');
                        window.$('#question-category').selectpicker('refresh');
                    });
            }
            if (this.props.errorsubjectupdate) {
                window.Swal.fire({
                    title: 'Failed to update subject!',
                    text: this.props.errorsubjectupdate,
                    icon: 'error',
                    customClass: {
                        confirmButton: `btn font-weight-bold ${confirmClass}`,
                    },
                    onOpen: (modalElement) => {
                        if (customer === customerConstants.EXO_CUSTOMER2) {
                            modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                        }
                    }
                })
                    .then(function () {
                        window.$('#manage-category').modal('hide')
                        window.$("#question-category").val('default');
                        window.$('#question-category').selectpicker('refresh');
                    });

            }
        }
    }

    generateSubjectOptions() {
        let subjectOptionsImport = []
        this.props.allQuestionSubjects.map((el, i) => {
            subjectOptionsImport.push(<Option key={el.subject_id} optionName={el.subject} value={el.subject_id} />)
        });

        this.setState({
            subjectOptionsImport: subjectOptionsImport,
            selectedSubject: subjectOptionsImport[0].props.value
        });

        if (subjectOptionsImport)
            window.$('#question-import-select').selectpicker('refresh');
    }
    
    async handleEditSubject(el, i, e) {
        e.preventDefault()
        this.setState({
            editSubject: true,
            selectSubject: i,
            subjectId: el.subject_id,
            subject: el.subject
        })
    }

    async handleDeleteModal(el, e) {
        e.preventDefault()
        window.Swal.fire({
            title: 'Do you want to delete the subject?',
            showCancelButton: true,
            confirmButtonColor: addBtnColor,
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await this.props.deleteSubject(el);
                if (this.props.successsubjectdelete) {
                    // await this.props.getAllQuestionSubjects(subject_limit, subject_offset, subject_sort_column, subject_sort_direction, subject_search_term);
                    this.fetchAllQuestionSubjects()
                    this.generateSubjectOptions();
                    window.Swal.fire({
                        title: 'Success!',
                        text: 'Deleted subject!',
                        icon: 'success',
                        customClass: {
                            confirmButton: `btn font-weight-bold ${confirmClass}`,
                        },
                        onOpen: (modalElement) => {
                            if (customer === customerConstants.EXO_CUSTOMER2) {
                                modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                            }
                        }
                    })
                        .then(function () {
                            window.$('#manage-category').modal('hide')
                            window.$("#question-category").val('default');
                            window.$('#question-category').selectpicker('refresh');
                        });
                }
                if (this.props.errorsubjectdelete) {
                    window.Swal.fire({
                        title: 'Failed to delete subject!',
                        text: this.props.errorsubjectdelete,
                        icon: 'error',
                        customClass: {
                            confirmButton: `btn font-weight-bold ${confirmClass}`,
                        },
                        onOpen: (modalElement) => {
                            if (customer === customerConstants.EXO_CUSTOMER2) {
                                modalElement.querySelector('.swal2-confirm').setAttribute('id', 'confirmButtonId');
                            }
                        }
                    })
                        .then(function () {
                            window.$('#manage-subject').modal('hide')
                            window.$("#question-subject").val('default');
                            window.$('#question-subject').selectpicker('refresh');
                        });

                }
            }
        })
    }
    
    syncTableSubject() {
        return (
            <>
                {this.state.subjectData.length > 0 ? (
                    <Table sx={{width:"75vw"}}>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    className="thead"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.handleSortSubjectChange("subject_id")}
                                >
                                    No{" "}
                                    {this.state.subject_sort_column === "subject_id" && (
                                    <span>{this.state.subject_sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                                    )}
                                </TableCell>
                                <TableCell
                                    className="thead"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => this.handleSortSubjectChange("subject")}
                                >
                                    Subject Name{" "}
                                    {this.state.subject_sort_column === "subject" && (
                                    <span>{this.state.subject_sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                                    )}
                                </TableCell>
                                <TableCell className="thead">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.subjectData.map((el, i) => {
                                if (i === this.state.selectSubject) {
                                    return (
                                        <TableRow key={i}>
                                            <TableCell className="tData">{i+1}</TableCell>
                                            <TableCell className="tData">
                                                {!this.state.editSubject ? 
                                                this.getQuestionSubject(el.subject_id) : 
                                                <Input type="text" inputWrap="col-lg-8" className="form-control" id="id-title"
                                                    name="title"
                                                    value={this.state.subject}
                                                    onChange={(e) => this.onEditSubject(e, el)} 
                                                />
                                                }
                                            </TableCell>
                                            <TableCell className="tData">{
                                                <div>
                                                    <Button 
                                                        onClick={(e) => this.onUpdateSubject(e)} 
                                                        className="btn btn-icon btn-success btn-sm m-1" 
                                                        btnIconStyle="flaticon2-correct" 
                                                        title="Save Subject" 
                                                    />
                                                </div>}
                                            </TableCell>
                                        </TableRow>
                                    )
                                } 
                                else 
                                {
                                return (
                                    <TableRow key={i}>
                                        <TableCell className="tData">{i+1}</TableCell>
                                        <TableCell className="tData">{this.getQuestionSubject(el.subject_id)}</TableCell>
                                        <TableCell className="tData">{
                                            <div>
                                                <Button 
                                                    onClick={(e) => this.handleEditSubject(el, i, e)} 
                                                    className="btn btn-icon action-btn btn-sm m-1" 
                                                    btnIconStyle="flaticon-edit" 
                                                    title="Edit Subject" 
                                                />
                                                <Button 
                                                    onClick={(e) => this.handleDeleteModal(el, e)} 
                                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"  
                                                    title="Delete Subject" 
                                                />
                                            </div>}
                                        </TableCell>
                                    </TableRow>
                                )
                                }
                            })}
                        </TableBody>
                    </Table>
                ) : (
                    <div className="text-center mb-5 mt-10">
                        <label>No Subjects Available!</label>
                    </div>
                    )}
            </>
        )
    }

    render(){
        return (
          <ContentWrapper>
            <div className="pt-5">
              <div className="col-md-12">
                <h3>Manage Subjects</h3>
              </div>

              <CardBody>
                <div className="row justify-content-end">
                  <div
                    className="table-wrapper-scroll-y my-custom-scrollbar"
                    data-wizard-type="step-content"
                    data-wizard-state="current"
                  >
                    <TabList>
                      <QuestionAccordion
                        labelName="Create New Subject"
                        onChange={this.onNewSubjectInput}
                        onClick={this.onAddNewSubject}
                        val={this.state.newSubject}
                      />
                    </TabList>
                    <div className="row justify-content-end col-md-12">
                      <Form.Group
                        controlId="exampleForm.ControlInput1"
                        className="mb-2"
                      >
                        <Form.Control
                          type="text"
                          placeholder="Search"
                          onChange={this.handleSubjectSearch}
                          className="col-md-18 col-18"
                        />
                      </Form.Group>
                    </div>
                    <TabContent>
                      <TabPane
                        className="tab-pane fade show active"
                        id="manage-1"
                        ariaLabelledby="manage-tab-1"
                      >
                        {/* begin: Datatable */}
                        {this.props.cat_loading ? (
                          <div style={{ width: "75vw", overflowX: "scroll" }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell className="thead">No</TableCell>
                                  <TableCell className="thead">
                                    Subject Name
                                  </TableCell>
                                  <TableCell className="thead">
                                    Actions
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                            </Table>
                            <div className="loading-container mb-5 mt-10">
                              <ReactSpinner
                                animation="border"
                                role="status"
                                style={{ display: "block", margin: "auto" }}
                              >
                                <span className="sr-only">Loading...</span>
                              </ReactSpinner>
                            </div>
                          </div>
                        ) : this.state.subjectData.length > 0 ? (
                          this.syncTableSubject()
                        ) : (
                          <div>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell className="thead">No</TableCell>
                                  <TableCell className="thead">
                                    Subject Name
                                  </TableCell>
                                  <TableCell className="thead">
                                    Actions
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              {/* end: Datatable */}
                            </Table>
                            <div className="text-center mb-5 mt-10">
                              <label>No Subjects Available!</label>
                            </div>
                          </div>
                        )}
                      </TabPane>
                    </TabContent>
                    <div className="d-flex justify-content-end">
                        <MaterialCustomTablePagination
                            totalCount = {this.props.totalSubjectsCount}
                            currentPage = {this.state.currentSubjectPage}
                            limit = {this.state.subjectRowsPerPage}
                            handlePageChange = {this.handleSubjectPageChange}
                            handleRowsPerPageChange = {this.handleSubjectRowsPerPageChange}
                            handlePageOffsetChange = {this.handlePageOffsetChange}
                            offset = {this.state.subject_offset}
                            rowsPerPageOptions={[5, 10, 15, 20, 25]}
                        />
                    </div>
                  </div>
                </div>
              </CardBody>
            </div>
          </ContentWrapper>
        )
    }
}

  function mapStateToProps(state) {
    return {
        totalSubjectsCount: state.subjectReducer.totalSubjectsCount,//
        cat_loading:state.subjectReducer.loading,
        error: state.subjectReducer.error,//
        // totalCount: state.questionsLibraryReducer.totalCount,//
        
        errorsubjectdelete: state.subjectReducer.errorsubjectdelete,
        successsubjectdelete: state.subjectReducer.successsubjectdelete,

        errorsubjectupdate: state.subjectReducer.errorsubjectupdate,
        successsubjectupdate: state.subjectReducer.successsubjectupdate,//
        
        errorsubjectcreate: state.subjectReducer.errorsubjectcreate,
        successsubjectcreate: state.subjectReducer.successsubjectcreate,//

        allQuestionSubjects: state.subjectReducer.allQuestionSubjects,//
        loading: state.subjectReducer.loading,//
    }
}

    const mapActionsToProps = {
        createSubject: quesSubjectActions.createSubject,
        getAllQuestionSubjects: quesSubjectActions.getAllQuestionSubjects,
        updateSubject: quesSubjectActions.updateSubject,
        deleteSubject: quesSubjectActions.deleteSubject,
    }

    export default connect(mapStateToProps, mapActionsToProps)(QuestionSubject);

